import { trpc } from '@/shared/api';

interface InvalidatePayments {
  readonly list: () => Promise<void>;
  readonly detail: (id: string) => Promise<void>;
}

/**
 * 결제 캐시 무효화 — 목록·상세 invalidation 을 한곳에 모은다.
 *
 * 재조회 promise 를 돌려준다 — 뮤테이션 onSettled 가 이것을 돌려주면 TanStack 이 재조회가 끝날 때까지
 * isPending 을 유지해, 새 잔액이 오기 전에 환불 버튼이 다시 풀리지 않는다. 재조회가 실패해도 거부하지 않는다.
 */
export const useInvalidatePayments = (): InvalidatePayments => {
  const utils = trpc.useUtils();

  return {
    list: () => utils.paymentManagement.list.invalidate(),
    detail: (id) => utils.paymentManagement.get.invalidate({ id }),
  };
};
